module.exports = __webpack_public_path__ + "img/9788964291016.1cda50c8.jpg";